import { Icon } from "./Icon";
import { cn } from "@/lib/utils";

interface RatingPillProps {
  value: number;
  max: number;
  className?: string;
}

export function RatingPill({ value, max, className = "" }: RatingPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-800",
        className,
      )}
    >
      <Icon name="star" size={12} className="fill-amber-500 text-amber-500" />
      {value}/{max}
    </span>
  );
}
